import styled from 'styled-components'
import { MINE_SHAFT } from 'constants/colors'

export const FormContainer = styled.div`
  padding: 30px 20px;
  width: 100%;
  min-width: 800px;
  max-width: 800px;
`

export const Heading = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-dark);
  margin-bottom: 24px;
`

export const FormGroup = styled.div`
  margin-bottom: 26px;
  position: relative;
`
export const FormLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: var(--color-text-form-label);
  margin-bottom: 10px;
  span {
    color: var(--color-text-error);
  }
  & .modal-tooltip {
    width: 250px;
    padding: 8px;
    border: 1px solid var(--color-issabeline-grey);
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 10px;
    z-index: 9999;
    opacity: 1;
    &.type-dark {
      background-color: ${MINE_SHAFT};
    }
  }
`

export const ErrorText = styled.div`
  color: var(--color-text-error);
  font-size: 12px;
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`
